<template>
<!--
    :class=" [scrollTop < -212 && scrollTop > -2774? 'on':'no']"

-->
  <div
    class="vip-fixed-header "
    :style="{ 'top': scrollTop < -212 && scrollTop > -2774? placeholderHeight+'px' : '-999px' }"
  >
    <div class="inner_center">
      <div class="members-package">
        <!--          <i class="icon_vip-member"/>-->
        <div class="authorization-scoped-wrap">
          <!-- 授权范围 -->
          <div class="authorization-scoped">
            授权范围
          </div>
          <!-- 权益保障 -->
        </div>

        <div class="member-package-item-wrap">
          <div class="member-package-item-hidden">
            <div class="member-package-item"
            >
              <div
                v-for="(v,i) in INTRO_COMPANY.VIP_CARD_LIST.slice(0,INTRO_COMPANY.VIP_CARD_LIST.length )"
                :key="i"
                class="package-person package-item"
                :class="'card-header' + (i+1) "
              >
                <div class="title">
                  <i class="icon_custom"></i>

                  <template v-if="v.ID != -999">
                    <div class="name">{{ v.LABEL }}</div>
                    <div class="price __price-wrap">
                      <span class="text-dollar">￥</span>
                      <span class="text-price">{{ v.PRICE }}</span>
                      <span class="text-year">/年</span>
                    </div>
                  </template>
                  <template v-else>
                    <div class="name name-custom">定制版</div>
                  </template>
                  <div
                    class="buy-btn"
                    @click="buy(v)">
                    {{ v.ID != -999 ? '立即购买' : '在线咨询' }}
                  </div>
                </div>
                <ul>
                  <li
                    v-for="(vo,idx) in v.interestList"
                    :key="'package1'+idx"
                    :class="[
                    {'h_74': [11,13,15,17,31,32].indexOf(idx) > -1,},
                    {'h_91': [14,21].indexOf(idx) > -1,},
                    {'h_108': [].indexOf(idx) > -1,}
                  ]"
                  >
                    <i
                      v-if=" vo === 0 || vo=== 1"
                      class="iconfont"
                      :class="[ vo === 0 ? 'icon-cha2': 'icon-gou' ]">
                    </i>
                    <span v-else>
                  {{ vo }}
                </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BUSINESS_VIP_INFO, PERSON_VIP_INFO,
  PERSON_QUARTER_MONTH_INFO, BUSINESS_VIP_MONTH_INFO
} from "@/constant/VIP";
import {info} from "~/components/member/common/module";
import {serviceLink} from "@/constant/CONFIG";
import {COMPANY_All_PURPOSE, COMPANY_ONLINE} from "@/constant/VIP_COMPANY";
import {INTRO_COMPANY} from "@/constant/intro/INTRO_COMPANY";
import Cookie from "js-cookie";

export default {
  name: "VipFixedHeader",
  data() {
    return {
      info,
      BUSINESS_VIP_INFO, PERSON_VIP_INFO,
      PERSON_QUARTER_MONTH_INFO,
      COMPANY_All_PURPOSE,
      BUSINESS_VIP_MONTH_INFO,
      COMPANY_ONLINE,
      isShow: false,
      serviceLink,
      INTRO_COMPANY,
      placeholderHeight: Cookie.get("headerHeight") || 80
    }
  },
  props: {
    scrollTop: {
      type: String | Number,
      default: 0
    }
  },
  methods: {
    buy(vipInfo) {
      this.$emit('buy', vipInfo)
    },
  }
}
</script>

<style lang="scss" scoped>

.vip-fixed-header {
  position: fixed;
  width: 1200px !important;
  //width: 1019px !important;
  //overflow: hidden;
  box-sizing: border-box;
  top: 76px;
  left: 50%;
  transform: translateX(-50%);
  height: 141px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 26, 0.06);
  z-index: 9;
  background-color: #fff;
  border: 1px solid #ECEFF6;
  transition: all 0.5s ease-in-out;
  margin-left: -24px;

  &.on {
    top: 76px;
  }

  &.no {
    top: -200px;
  }

  .inner_center {
    display: flex;
    height: 100%;
  }

  .members-package {
    height: 141px;
    display: flex;
    border-radius: 20px;
    border: 1px solid #ECEFF6;
    //overflow: hidden;
    box-shadow: 0px 0px 25px 0px rgba(0, 0, 26, 0.06);
    //margin: -114px auto 80px;
    width: 1200px;
    background-color: #fff;
    box-sizing: border-box;
    position: relative;

    .icon_vip-member {
      @include BgImage(554px, 119px, 'introduce/icon_vip-member.png');
      @include Position(1, 5, 56px, -84px);
      z-index: 2;
    }

    .authorization-scoped-wrap {
      line-height: 141px;
      width: 275px;
      flex-shrink: 0;
      /* 抽离公共代码 */
      .authorization-item {
        display: flex;
        //border: 1px solid #ECEFF6;
        border-left: 0;
        box-sizing: border-box;
        border-top: 0;
        position: relative;
        z-index: 5;

        .title {
          width: 170px;
          border-right: 1px solid #ECEFF6;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          color: rgba(66, 72, 102, 0.85);
          text-align: center;
          font-size: 17px;
        }

        ul {
          flex: 1;

          li {
            //height: 84px;
            //height: 80px;
            padding: 19px 16px 20px 26px;
            box-sizing: border-box;
            border-bottom: 1px solid #ECEFF6;
            border-right: 1px solid #ECEFF6;
            display: flex;
            //align-items: center;
            justify-content: center;
            flex-direction: column;

            &:first-child {
              background: rgba(255, 237, 217, 1);

              .name {
                font-size: 14px;
                font-weight: bold;
                color: #2D2B33;
              }
            }

            &:last-child {
              //border-bottom: 0;
            }

            &.NO {
              height: 57px;

              .name {
                margin-bottom: 0px;
              }
            }

            &:nth-child(1),
            &:nth-child(11),
            &:nth-child(13),
            &:nth-child(17),
            &:nth-child(19),
            &:nth-child(21),
            &:nth-child(23),
            &:nth-child(25),
            &:nth-child(27),
            &:nth-child(29),
            &:nth-child(31),
            {
              border-right: none;
              border-bottom: none;
              margin-top: -1px;
            }


            &:nth-child(1) {

            }

            .name {
              font-size: 13px;
              color: #424866;
              line-height: 17px;
            }

            .desc {
              //color: #424866;
              //line-height: 19px;
              //font-size: 13px;
            }
          }
        }

        &:last-child {
          border-bottom: 0;
        }
      }

      .authorization-scoped {
        box-sizing: border-box;
        text-align: center;
        font-size: 22px;
        font-weight: bold;
        color: #424866;
        //border-bottom: 1px solid #ECEFF6;
        //border-right: 1px solid #ECEFF6;
        position: relative;
        z-index: 5;
        background-color: #FFFFFF;
      }
    }

    .member-package-item-wrap {
      width: 930px;
      position: relative;

      .member-package-item-hidden {
        width: 100%;
        width: 930px;
        height: 100%;
        overflow: hidden;
        position: relative;
      }

      .custom-bar {
        width: 48px;
        background: linear-gradient(180deg, #FFD3A3 0%, #FFDFB3 100%);
        border-radius: 0px 20px 20px 0px;
        @include Position(1, 2, -48px, 3px);
        bottom: 0;
        padding-top: 210px;
        text-align: center;
        //height: 95px;
        font-size: 14px;
        font-weight: bold;
        color: #733D15;
        line-height: 19px;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;

        span {
          display: inline-block;
          width: 15px;
          line-height: 19px;
          margin-bottom: 6px;
        }
      }
    }

    .member-package-item {
      @include Position(1, 5, 0, 0);
      display: flex;
      //position: relative;
      //top: -97px;
      //z-index: 10;
      //margin-top: -97px;
      background-color: #fff;
      //overflow: hidden;
      border-top: 1px solid #ECEFF6;
      //border: 1px solid #ECEFF6;
      //border-bottom: none;
      transition: all 0.5s ease-in-out;

      .package-item {
        width: 186px;
        flex-shrink: 0;

        .title {
          height: 141px;
          box-sizing: border-box;
          //border-right: 1px solid #ECEFF6;
          border-left: 1px solid #ECEFF6;
          position: relative;

          @include LayoutFlex(2);

          .icon-prefs {
            @include Position(1, 5, 0, 0);
            width: 124px;
            height: 28px;
            background: linear-gradient(90deg, #FFD16C 0%, #FFAD63 100%);
            border-radius: 20px 0px 8px 0px;
            color: #FFFFFF;
            line-height: 28px;
            display: flex;
            align-items: center;
            font-size: 0;

            .icon_prefs {
              @include BgImage(15px, 15px, 'member/icon_prefs.png');
              margin: 0 4px 0 15px;

            }

            .icon-prefs-txt {
              font-size: 13px;
            }
          }

          .name {
            font-weight: bold;
            color: #0A2540;
            font-size: 16px;
            line-height: 21px;
            letter-spacing: 1px;

            &.name-custom {
              font-size: 16px;
              font-weight: bold;
              color: #233E90;
              line-height: 21px;
              letter-spacing: 1px;
              margin-bottom: 24px;
              padding-top: 18px;
            }
          }

          .__price-wrap {
            font-size: 0;
            //margin: 8px 0 10px 0;
            margin: 2px 0;
            color: #596088;
            font-weight: bold;

            .text-dollar {
              font-size: 18px;
              line-height: 24px;
              color: #2D2B33;
              vertical-align: 2px;

            }

            .text-price {
              //letter-spacing: 1px;
              //margin: 0 4px;
              margin-left: 4px;

              font-size: 28px;
              font-weight: bold;
              color: #2D2B33;
              line-height: 42px;
            }

            .text-year {
              font-size: 18px;
              line-height: 24px;
              color: #2D2B33;
            }
          }

          .buy-btn {
            width: 132px;
            height: 38px;
            line-height: 38px;
            text-align: center;
            cursor: pointer;
            transition: all 0.3s ease-in;
            //background: #35D0BA;
            background: #FF5758;
            border-radius: 22px;
            font-size: 13px;
            font-weight: bold;
            color: #FFFFFF;
            @include ElementHover('', #FF6869);
          }

        }

        ul {

          li {
            height: 57px;
            box-sizing: border-box;
            border-bottom: 1px solid #ECEFF6;
            border-right: 1px solid #ECEFF6;
            @include LayoutFlex(1);


            &.h_80 {
              height: 81.9px;
            }

            &.h_100 {
              height: 100px;
            }

            &.h_74 {
              height: 74px;
            }

            &.h_90 {
              height: 90px;
            }

            &.h_91 {
              height: 91px;
            }

            &.h_108 {
              height: 108px;
            }

            &:nth-child(9) {
              //height: 60.5px;
            }

            &:nth-child(12) {
              height: 313px;
            }

            &:nth-child(18) {
              height: 165px;
            }

            &:nth-child(20) {
              height: 165px;
            }

            &:nth-child(24) {
              height: 148px;
            }

            &:nth-child(28) {
              height: 182px;
            }

            &:nth-child(1),
            &:nth-child(11),
            &:nth-child(13),
            &:nth-child(17),
            &:nth-child(19),
            &:nth-child(21),
            &:nth-child(23),
            &:nth-child(25),
            &:nth-child(27),
            &:nth-child(29),
            &:nth-child(31),
            {
              background: #ffedd9;
              border-right: none;
              border-bottom: none;
              margin-top: -1px;
            }


            .iconfont {
              font-size: 22px;
            }

            .icon-gou {
              color: #35D0BA;
            }

            .icon-cha2 {
              color: #A4A9BE;
            }

            &:last-child {
              border-bottom: 0;
            }

            span {
              font-size: 14px;
              color: #2D2B33;
              line-height: 20px;
            }
          }
        }

        &:first-child {
          ul {
            li {
              //border-right: 1px solid #ECEFF6;
            }
          }
        }

        &:last-child {
          li {
            border-right: none;
          }

          .title {
            border-right: 0;
            //width: 261px;
            //background-color: #FFFFFF;
            position: relative;

            &:after {
              /*content: '';
              width: 10px;
              @include Position(1, 2, -1px, 0);
              bottom: 0;
              background-color: #FFFFFF;
              border-radius: 20px 20px 0px 0px;*/
            }
          }
        }

      }

      .card-header5 {

        .title {
          background: linear-gradient(180deg, #FFEEC3 0%, #FFD489 100%);
          position: relative;

          .icon_custom {
            @include BgImage2(242px, 180px, 'introduce/company/icon_custom.png');
            position: absolute;
            top: 0;
            right: 0;

          }
          .name,.buy-btn{
            position: relative;
            z-index: 2;

          }
          .buy-btn{
            border: 2px solid #FFFFFF;
            //line-height: 34px;
            background: linear-gradient(227deg, #FF5C4B 0%, #FF007F 100%) !important;
            box-shadow: 0px 2px 4px 0px rgba(199,132,15,0.17);
            //box-sizing: border-box;
            &:hover{
              background: linear-gradient(227deg, #FF007F 0%, #FF5C4B 100%) !important;
            }
          }


        }
      }
    }
  }
}


</style>
